// utils/urlParams.js - Helper functions for URLSearchParams

// Build params from table state
export const buildTableParams = (state) => {
  const params = new URLSearchParams();

  // Pagination
  params.append("page", state.page);
  params.append("pageSize", state.pageSize);

  // Sorting
  if (state.sorted && state.sorted.length) {
    // state.sorted.forEach((sort, index) => {
    //   params.append(`sort[${index}][id]`, sort.id);
    //   params.append(`sort[${index}][desc]`, sort.desc);
    // });
    params.append(`sorted`, JSON.stringify(state.sorted));
  }

  // Filters
  if (state.filtered && state.filtered.length) {
    // state.filtered.forEach((filter) => {
    //   if (filter.value && filter.value.toString().trim()) {
    //     params.append(`filter[${filter.id}]`, filter.value);
    //   }
    // });
    params.append(`filtered`, JSON.stringify(state.filtered));
  }

  return params;
};

// Parse URL params back to table state (useful for deep linking)
export const parseTableParams = (searchParams) => {
  const page = parseInt(searchParams.get("page")) || 0;
  const pageSize = parseInt(searchParams.get("pageSize")) || 10;

  const sorted = [];
  const filtered = [];

  // Parse sorting
  let index = 0;
  while (searchParams.has(`sort[${index}][id]`)) {
    sorted.push({
      id: searchParams.get(`sort[${index}][id]`),
      desc: searchParams.get(`sort[${index}][desc]`) === "true",
    });
    index++;
  }

  // Parse filters
  for (let [key, value] of searchParams.entries()) {
    if (key.startsWith("filter[")) {
      const id = key.match(/filter\[(.*?)\]/)[1];
      if (value) {
        filtered.push({ id, value });
      }
    }
  }

  return { page, pageSize, sorted, filtered };
};
